import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "calender-remove, date-remove" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M5.16667 3.16536H4.5C3.39543 3.16536 2.5 4.0608 2.5 5.16536V6.16536M5.16667 3.16536H10.8333M5.16667 3.16536V1.83203M10.8333 3.16536H11.5C12.6046 3.16536 13.5 4.0608 13.5 5.16536V6.16536M10.8333 3.16536V1.83203M7.5 13.4987H4.5C3.39543 13.4987 2.5 12.6033 2.5 11.4987V6.16536M2.5 6.16536H13.5M13.5 6.16536V7.4987M10.4992 10.4987L11.9992 11.9987M11.9992 11.9987L13.4992 13.4987M11.9992 11.9987L10.4992 13.4987M11.9992 11.9987L13.4992 10.4987",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }